/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { OpportunityBreakdown } from "./OpportunityBreakdown";
import {
  OpportunityBreakdownFromJSON,
  OpportunityBreakdownFromJSONTyped,
  OpportunityBreakdownToJSON,
  OpportunityBreakdownToJSONTyped,
} from "./OpportunityBreakdown";
import type { OpportunitySummary } from "./OpportunitySummary";
import {
  OpportunitySummaryFromJSON,
  OpportunitySummaryFromJSONTyped,
  OpportunitySummaryToJSON,
  OpportunitySummaryToJSONTyped,
} from "./OpportunitySummary";
import type { OpportunityFreightProfile } from "./OpportunityFreightProfile";
import {
  OpportunityFreightProfileFromJSON,
  OpportunityFreightProfileFromJSONTyped,
  OpportunityFreightProfileToJSON,
  OpportunityFreightProfileToJSONTyped,
} from "./OpportunityFreightProfile";
import type { OpportunityLane } from "./OpportunityLane";
import {
  OpportunityLaneFromJSON,
  OpportunityLaneFromJSONTyped,
  OpportunityLaneToJSON,
  OpportunityLaneToJSONTyped,
} from "./OpportunityLane";
import type { OpportunityDataWindow } from "./OpportunityDataWindow";
import {
  OpportunityDataWindowFromJSON,
  OpportunityDataWindowFromJSONTyped,
  OpportunityDataWindowToJSON,
  OpportunityDataWindowToJSONTyped,
} from "./OpportunityDataWindow";
import type { OpportunityCoverage } from "./OpportunityCoverage";
import {
  OpportunityCoverageFromJSON,
  OpportunityCoverageFromJSONTyped,
  OpportunityCoverageToJSON,
  OpportunityCoverageToJSONTyped,
} from "./OpportunityCoverage";

/**
 *
 * @export
 * @interface OpportunityPackage
 */
export interface OpportunityPackage {
  /**
   *
   * @type {OpportunitySummary}
   * @memberof OpportunityPackage
   */
  summary: OpportunitySummary;
  /**
   *
   * @type {OpportunityDataWindow}
   * @memberof OpportunityPackage
   */
  dataWindow: OpportunityDataWindow;
  /**
   * Every origin, not just the busiest few.
   * @type {Array<OpportunityBreakdown>}
   * @memberof OpportunityPackage
   */
  pickupLocations: Array<OpportunityBreakdown>;
  /**
   * The complete lane table.
   * @type {Array<OpportunityLane>}
   * @memberof OpportunityPackage
   */
  lanes: Array<OpportunityLane>;
  /**
   *
   * @type {OpportunityFreightProfile}
   * @memberof OpportunityPackage
   */
  freightProfile: OpportunityFreightProfile;
  /**
   *
   * @type {Array<OpportunityBreakdown>}
   * @memberof OpportunityPackage
   */
  weightBands: Array<OpportunityBreakdown>;
  /**
   *
   * @type {Array<OpportunityBreakdown>}
   * @memberof OpportunityPackage
   */
  densityBands: Array<OpportunityBreakdown>;
  /**
   * Shipments per month across the data window, oldest first.
   * @type {Array<OpportunityBreakdown>}
   * @memberof OpportunityPackage
   */
  monthlyVolume: Array<OpportunityBreakdown>;
  /**
   *
   * @type {OpportunityCoverage}
   * @memberof OpportunityPackage
   */
  coverage?: OpportunityCoverage;
  /**
   *
   * @type {boolean}
   * @memberof OpportunityPackage
   */
  datafileAvailable: boolean;
  /**
   *
   * @type {string}
   * @memberof OpportunityPackage
   */
  datafileName?: string;
  /**
   *
   * @type {string}
   * @memberof OpportunityPackage
   */
  datafileUploadedAt?: string;
}

/**
 * Check if a given object implements the OpportunityPackage interface.
 */
export function instanceOfOpportunityPackage(
  value: object,
): value is OpportunityPackage {
  if (!("summary" in value) || value["summary"] === undefined) return false;
  if (!("dataWindow" in value) || value["dataWindow"] === undefined)
    return false;
  if (!("pickupLocations" in value) || value["pickupLocations"] === undefined)
    return false;
  if (!("lanes" in value) || value["lanes"] === undefined) return false;
  if (!("freightProfile" in value) || value["freightProfile"] === undefined)
    return false;
  if (!("weightBands" in value) || value["weightBands"] === undefined)
    return false;
  if (!("densityBands" in value) || value["densityBands"] === undefined)
    return false;
  if (!("monthlyVolume" in value) || value["monthlyVolume"] === undefined)
    return false;
  if (
    !("datafileAvailable" in value) ||
    value["datafileAvailable"] === undefined
  )
    return false;
  return true;
}

export function OpportunityPackageFromJSON(json: any): OpportunityPackage {
  return OpportunityPackageFromJSONTyped(json, false);
}

export function OpportunityPackageFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): OpportunityPackage {
  if (json == null) {
    return json;
  }
  return {
    summary: OpportunitySummaryFromJSON(json["summary"]),
    dataWindow: OpportunityDataWindowFromJSON(json["dataWindow"]),
    pickupLocations: (json["pickupLocations"] as Array<any>).map(
      OpportunityBreakdownFromJSON,
    ),
    lanes: (json["lanes"] as Array<any>).map(OpportunityLaneFromJSON),
    freightProfile: OpportunityFreightProfileFromJSON(json["freightProfile"]),
    weightBands: (json["weightBands"] as Array<any>).map(
      OpportunityBreakdownFromJSON,
    ),
    densityBands: (json["densityBands"] as Array<any>).map(
      OpportunityBreakdownFromJSON,
    ),
    monthlyVolume: (json["monthlyVolume"] as Array<any>).map(
      OpportunityBreakdownFromJSON,
    ),
    coverage:
      json["coverage"] == null
        ? undefined
        : OpportunityCoverageFromJSON(json["coverage"]),
    datafileAvailable: json["datafileAvailable"],
    datafileName:
      json["datafileName"] == null ? undefined : json["datafileName"],
    datafileUploadedAt:
      json["datafileUploadedAt"] == null
        ? undefined
        : json["datafileUploadedAt"],
  };
}

export function OpportunityPackageToJSON(json: any): OpportunityPackage {
  return OpportunityPackageToJSONTyped(json, false);
}

export function OpportunityPackageToJSONTyped(
  value?: OpportunityPackage | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    summary: OpportunitySummaryToJSON(value["summary"]),
    dataWindow: OpportunityDataWindowToJSON(value["dataWindow"]),
    pickupLocations: (value["pickupLocations"] as Array<any>).map(
      OpportunityBreakdownToJSON,
    ),
    lanes: (value["lanes"] as Array<any>).map(OpportunityLaneToJSON),
    freightProfile: OpportunityFreightProfileToJSON(value["freightProfile"]),
    weightBands: (value["weightBands"] as Array<any>).map(
      OpportunityBreakdownToJSON,
    ),
    densityBands: (value["densityBands"] as Array<any>).map(
      OpportunityBreakdownToJSON,
    ),
    monthlyVolume: (value["monthlyVolume"] as Array<any>).map(
      OpportunityBreakdownToJSON,
    ),
    coverage: OpportunityCoverageToJSON(value["coverage"]),
    datafileAvailable: value["datafileAvailable"],
    datafileName: value["datafileName"],
    datafileUploadedAt: value["datafileUploadedAt"],
  };
}
